/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';

/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/packages/packages-block-editor/#useBlockProps
 */
import { useBlockProps } from '@wordpress/block-editor';

/**
 * The save function defines the way in which the different attributes should
 * be combined into the final markup, which is then serialized by the block
 * editor into `post_content`.
 *
 * @see https://developer.wordpress.org/block-editor/developers/block-api/block-edit-save/#save
 *
 * @return {WPElement} Element to render.
 */
export default function save( { attributes } ) {

	const blockProps = useBlockProps.save();
	const scrolling  = true === attributes.iframeBlockScrolling ? 'yes' : 'no';

	let iframeCSS = {
		border: "none",
		maxWidth: '100%'
	};

	if ( true === attributes.iframeBlockResponsiveWidth ) {
		iframeCSS['width'] = attributes.iframeBlockWidth + '%';
	} else {
		iframeCSS['width'] = attributes.iframeBlockWidth + 'px';
	}

	if ( true === attributes.iframeBlockResponsiveHeight ) {
		iframeCSS['height'] = attributes.iframeBlockHeight + '%';
	} else {
		iframeCSS['height'] = attributes.iframeBlockHeight + 'px';
	}

	return (
		<div className={'iframe-block-container'}>
			{
				typeof attributes.iframeBlockSrc !== 'undefined' && attributes.iframeBlockSrc.length > 5 ?

					true === attributes.iframeBlockFullScreen ?

						<iframe src={attributes.iframeBlockSrc} style={iframeCSS} frameBorder={0} scrolling={scrolling} allowFullScreen={"allowFullScreen"}></iframe>
						:
						<iframe src={attributes.iframeBlockSrc} style={iframeCSS} frameBorder={0} scrolling={scrolling}></iframe>

					: ''
			}
		</div>
	);
}
